import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Header from '@components/header'
import Layout from '@components/Layout'
import ViewOutgoingPaymentModal from '@components/Modal/outgoingPaymentModal'
import { columnOutgoingPayment } from '@utils/columns'
import { debouncedSet } from '@utils/debounce'
import { downloadExcel } from '@utils/downloadPdf'
import { fetchOutgoingPayments, fetchCashAccounts } from '@utils/fetchData'
import { getToday } from '@utils/time'

import ChooseTypePayment from './ChooseTypePayment'
import CreateOutgoingPaymentModal from './Create'
import PayEmployeesModal from './PayEmployees'
import PaySupplierModal from './PaySupplier'
import SendMoneyToOffice from './SendMoneyToOffice/index';


const OutgoingPayments = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()
	const roleNames = useSelector((state) => state.main.roleNames)

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [addModalVisible, setIsAddModalVisible] = useState(false)
	const [payModalVisible, setIsPayModalVisible] = useState(false)
	const [isPayEmployeeModalVisible, setIsPayEmployeeModalVisible] =
		useState(false)
		const [sendMoneyVisible, setSendMoneyVisible] = useState(false)

	const [selectedRowData, setSelectedRowData] = useState(null)
	const [docNum, setDocNum] = useState('')
	const [cardName, setCardName] = useState('')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState(formattedDate)
	const [loadingExcel, setLoadingExcel] = useState(false)

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: [
			'outgoingPayments',
			currentPage,
			cardName,
			docNum,
			startDate,
			endDate,
		],
		queryFn: fetchOutgoingPayments,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: cashAccs = [] } = useQuery({
		queryKey: ['cashAccounts'],
		queryFn: fetchCashAccounts,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleAddClick = () => {
		setIsAddModalVisible(true)
	}

	const handlePaySupplierModal = () => {
		setIsPayModalVisible(true)
	}
	const handlePayEmployeeModal = () => {
		setIsPayEmployeeModalVisible(true)
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}
	const handleStartDate = (e) => {
		setStartDate(e.target.value)
	}

	const handleEndDate = (e) => {
		setEndDate(e.target.value)
	}

	const handleDocNumChange = (val) => {
		debouncedSet(val, setDocNum)
	}

	const handleCardNameChange = (val) => {
		debouncedSet(val, setCardName)
	}

	const columns = columnOutgoingPayment(
		t,
		handleRowClick,
		handleDocNumChange,
		handleCardNameChange,
		cashAccs,
	)

	const handleDownloadExcel = () => {
		downloadExcel({
			url: 'api/excelgenerators/export-vendor-payments',
			params: {
				cashAcctName: cardName,
				docNum,
				startDate,
				endDate,
				pageSize: 1000,
				pageToken: 0,
			},
			fileName: 'Xarajatlar',
			onLoadingChange: setLoadingExcel,
		})
	}

	const renderAddButtons = () => {
		return (
<button
							onClick={() => setSendMoneyVisible(true)}
							className="h-[30px] min-w-[140px] px-3  bg-[#099204] rounded-lg text-white "
						>
						{t('sendMoneyToOfis')}
						</button>
		)
	}

	return (
		<Layout>
			<Header
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onStartDateChange={handleStartDate}
				onEndDateChange={handleEndDate}
				startDate={startDate}
				endDate={endDate}
				formattedDate={formattedDate}
				onBtnClick={handleAddClick}
				isSticky={false}
				isShowExcelBtn
				handleDownloadExcel={handleDownloadExcel}
				loadingExcel={loadingExcel}
			{...(roleNames.includes('Cashier') ? 	{renderAddButtons: renderAddButtons } : {})}
				{...(roleNames.includes('Cashier')
					? { onPayVendorClick: handlePaySupplierModal }
					: {})}
				{...(roleNames.includes('Cashier')
					? { onPayEmployeeClick: handlePayEmployeeModal }
					: {})}
				{...(roleNames.includes('Cashier')
					? { isPayVendor: true }
					: { isPayVendor: false })}
				{...(roleNames.includes('Cashier')
					? { isPayEmployee: true }
					: { isPayEmployee: false })}
				{...(roleNames.includes('admin')
					? { title: 'expenses' }
					: { title: 'outgoingPayment' })}
			/>
			<ViewOutgoingPaymentModal
				visible={isModalVisible}
				data={selectedRowData}
				onClose={() => {
					refetch()
					setIsModalVisible(false)
				}}
				refetch={refetch}
			/>
			{!roleNames.includes('admin') && (
				<CreateOutgoingPaymentModal
					visible={addModalVisible}
					onClose={() => {
						setIsAddModalVisible(false)
						refetch()
					}}
				/>
			)}
			{!roleNames.includes('admin') && (
				<SendMoneyToOffice
					visible={sendMoneyVisible}
					onClose={() => {
						setSendMoneyVisible(false)
					}}
					onSuccess={() => {
						setSendMoneyVisible(false)
						refetch()
					}}
				/>
			)}
			{roleNames.includes('admin') && (
				<ChooseTypePayment
					visible={addModalVisible}
					onClose={() => {
						setIsAddModalVisible(false)
						refetch()
					}}
				/>
			)}
			<PaySupplierModal
				visible={payModalVisible}
				onClose={() => {
					setIsPayModalVisible(false)
					refetch()
				}}
			/>
			<PayEmployeesModal
				visible={isPayEmployeeModalVisible}
				onClose={() => {
					setIsPayEmployeeModalVisible(false)
					refetch()
				}}
			/>
		</Layout>
	)
}

export default OutgoingPayments
